import styled from '@emotion/styled'
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form'
import { Checkbox } from '@pubstack/ui/components/Checkbox'
import { TrackingLabel } from './layout/ProductTrackingIntegration'

const CheckboxList = styled.div<{ vertical?: boolean }>`
    display: flex;
    flex-direction: ${({ vertical }) => (vertical ? 'column' : 'row')};
    gap: 4px;
`

export type CheckboxOptions = {
  value: string
  label: string
  trackingLabel: TrackingLabel
}

type CheckboxGroupProps<T extends FieldValues> = {
  options: CheckboxOptions[]
  error?: string
  vertical?: boolean
} & UseControllerProps<T>

export const CheckboxGroup = <T extends FieldValues>({ options, control, name, vertical }: CheckboxGroupProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const handleChange = (value: string) => {
          const current: string[] = field.value || []
          const updated = current.includes(value) ? current.filter((v: string) => v !== value) : [...current, value]
          field.onChange(updated)
        }

        return (
          <CheckboxList vertical={vertical}>
            {options.map((option) => (
              <Checkbox key={option.value} checked={field.value?.includes(option.value)} onChange={() => handleChange(option.value)} label={option.label} trackingLabel={option.trackingLabel} />
            ))}
          </CheckboxList>
        )
      }}
    />
  )
}
